
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';
import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;

@Component({

  selector: 'app-change-address',

  templateUrl: './change-address.component.html',

  styleUrls: ['./change-address.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class ChangeAddressComponent implements OnInit {


  list_Schools: any = [];

  list_Students: any = [];

  list_address = [];

  filteredSchools = [];

  filteredStudents = [];

  lstPassenger: any = [];

  searchT_School = '';

  searchT_Student = '';

  iPassenger!: number;

  iMobileDomain!: number;

  dateFilter: FormGroup = this.FormBuilder.group({

    fromDate: new FormControl(''),

    toDate: new FormControl(''),

  })

  studentData: any;

  map: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];

  isLoading: boolean = false;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getSchools();

  }

  filterSchool() {

    if (this.searchT_School == '') this.filteredSchools = [];

    else this.filteredSchools = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchT_School));

  }

  filterStudent() {

    if (this.searchT_Student == '') this.filteredStudents = []

    else this.filteredStudents = this.list_Students.filter((item: any) => item.strPassenger_FullName.includes(this.searchT_Student));


  }

  onStudent_selected(item: any) {

    this.searchT_Student = item.strPassenger_FullName;

    this.iPassenger = item.iPassenger

    this.filteredStudents = [];


  }

  async getSchools() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

  }

  async getStudent(item: any) {

    this.searchT_School = item.strComment;

    this.filteredSchools = [];

    this.iMobileDomain = item.iMobileDomain

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: '',

      strFullName: '',

      tiSex: -1,

      iMobileDomain: item.iMobileDomain

    }

    let res = JSON.parse((await axios.post(`School_Passenger_List`, model)).data.toString());

    this.list_Students = res;

    this.filteredStudents = res;


  }

  async search_student() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strSDate: this.dateFilter.value.fromDate,

      strEDate: this.dateFilter.value.toDate,

      iPassenger: this.iPassenger != undefined ? this.iPassenger : -1,

      iMobileDomain: this.iMobileDomain != undefined ? this.iMobileDomain : -1,

    }

    let res = JSON.parse((await axios.post(`School_ChangeAddress_List`, model)).data.toString())

    this.list_address = res;

    this.isLoading = false;

  }

  async sendMessage(form: NgForm) {

    if (form.value.strMessage == '') return this.Notification.showError('لطفا متن پیام را مشخص کنید');

    if (!form.value.bSendPush && !form.value.bSaveMessage) return this.Notification.showError('لطفا نحوه ارسال پیام را مشخص کنید');

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['lstPassenger'] = this.lstPassenger;

    let res = JSON.parse((await axios.post(`School_Passenger_SendMessage`, form.value)).data.toString());

    if (res.iResult) {

      $('#sendMessage').modal('hide');

      return this.Notification.showSuccess('پیام با موفقیت ارسال شد');
    }

    else return this.Notification.showError(res.strError)


  }

  async saveAddress(form: NgForm) {

    if (form.value.tiStatus == 0) return this.Notification.showError('لطفا وضعیت را مشخص کنید')

    if (form.value.iCost == "۰ ریال") form.value.iCost = 0;

    else {

      form.value.iCost = form.value.iCost.replace(/,/g, '');

      form.value.iCost = form.value.iCost.replace(/ ریال/g, '');
    }

    form.value['iSchool_ChangeAddress'] = this.studentData.iSchool_ChangeAddress;

    let res = JSON.parse((await axios.post(`School_ChangeAddress_Edit`, form.value)).data.toString())[0];

    if (!res.iResult) {

      $('#detailModal').modal('hide');

      const index = this.list_address.indexOf(this.studentData as never);

      if (index != -1) (this.list_address as any)[index] = res

      return this.Notification.showSuccess('با موفقیت ویرایش شد');
    }

    else return this.Notification.showError(res.strError)


  }

  showDetail(item: any) {

    // console.log(item)

    item.strAvatar = '';

    this.studentData = item;

    $('#detailModal').modal('show');


  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iPassenger);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iPassenger) {

          const index = this.lstPassenger.indexOf(item.iPassenger);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })
    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;
  }

  selectAllCheckBox() {

    if (this.list_address.length > 0 && (this.list_address.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.list_address.forEach((a: any) => {

        this.lstPassenger.push(a.iPassenger);

      })

      this.Notification.showSuccess('همه دانش آموزان انتخاب شدند')

    }

    else this.lstPassenger = [];

  }

  showOnMap(long: number, lat: number) {

    let location = [long, lat];

    $('#stdLocation').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }


      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat(location),

          zoom: 13,

        }),

      });

    }, 500);

  }

  message_Modal() {

    if (this.lstPassenger.length == 0) return this.Notification.showError('لطفا دانش آموز مورد نظر خود را انتخاب کنید');

    $('#sendMessage').modal('show')
  }

  goBack() {

    this.router.navigate(['/'])

  }


}
